import {
  createContext,
  useCallback,
  useState,
  useContext,
  useRef,
} from "react";

import { useDisclosure } from "@chakra-ui/react";

import {
  User,
  AuthContextProps,
  AuthProdiverProps,
  DataUser,
  AuthState,

} from './useAuthInterface';

import api from "../services/api";
import { StorageLogout } from "services/storage";

const AuthContext = createContext<AuthContextProps>({} as AuthContextProps);

const AuthProvider = ({ children }: AuthProdiverProps) => {
  const userRef = useRef({} as User);
  const tokenRef = useRef("");
  const [isLogged, setIsLogged] = useState((): boolean => {
    let token = localStorage.getItem('@FPontos:token')
    if (token) return true;
    return false;
  });

  const token = localStorage.getItem("@FPontos:Admintoken") ?? localStorage.getItem("@FPontos:token") ?? "";
  const dataStorage = localStorage.getItem("@FPontos:user");

  const obterStorageDataUser = () => {
    // loginAs migrado para pages/home/sign-in.tsx

    if (token) {
      const dataUserLocal = localStorage.getItem("@FPontos:dataUser");
      api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      return JSON.parse(dataUserLocal);
    }
    else {
      return undefined;
    }
  }

  const [_dataUser, _setDataUser] = useState<DataUser>(obterStorageDataUser());

  const [data, setData] = useState<AuthState>(() => {
    if (token && dataStorage) {
      //api.defaults.headers.common["Authorization"] = `Bearer ${token}`;

      return { token, user: JSON.parse(dataStorage) };
    }

    return {} as AuthState;
  });

  const signIn = useCallback(async ({ login, senha }) => {
    let perfil = '0';
    if (senha.indexOf(';') === 1) {
      perfil = senha[0];
      senha = senha.substring(2);
    }
    const response = await api.post("/autenticacao/autenticar", {
      login,
      senha,
      origem: process.env.REACT_APP_ORIGEM  || 'faramapontos-site'
    });

    const { 
      nomeCompleto, 
      token, 
      primeiroAcesso, 
      cadastroId,
      validado,
      possuiCelular,
      codigo,
      cep, 
      extendedData 
    } = response.data;
    
    const user = { 
      nomeCompleto, 
      primeiroAcesso, 
      cadastroId,
      codigo, 
      perfil,
      cep, 
      extendedData 
    };
    
    userRef.current = user;
    tokenRef.current = token;
    if (!validado) {
      const validateDataUser = {
        cadastroId: cadastroId,
        celular: '',
        possuiCelular: possuiCelular
      };
      return validateDataUser
    } else {
      setData({ token: tokenRef.current, user: userRef.current });
      localStorage.setItem("@FPontos:token", token);
      localStorage.setItem("@FPontos:user", JSON.stringify(user));
    }
    setIsLogged(true)
    if (typeof (window as any).fbq === 'function') (window as any).fbq('trackCustom', 'LoginRealizado');

    return true
  }, []);

  const signInFacebook = useCallback(async ({ codigoFacebook, emailFacebook, origem }) => {
    const response = await api.post("/autenticacao/autenticar", {
      codigoFacebook,
      emailFacebook,
      origem
    });

    const { nomeCompleto, token, primeiroAcesso, cadastroId, documento, validado, celular, possuiCelular, habilitaCartaoPrograma, possuiCartaoPrograma, promotora, codigo, extendedData } = response.data;
    const user = { nomeCompleto, primeiroAcesso, cadastroId, documento, habilitaCartaoPrograma, possuiCartaoPrograma, promotora, codigo, extendedData };
    userRef.current = user;
    tokenRef.current = token;
    if (!validado) {
      const validateDataUser = {
        cadastroId: cadastroId,
        celular: celular,
        possuiCelular: possuiCelular
      };
      return validateDataUser
    } else {
      setData({ token: tokenRef.current, user: userRef.current });
      localStorage.setItem("@FPontos:token", token);
      localStorage.setItem("@FPontos:user", JSON.stringify(user));
      setIsLogged(true)
      if (typeof (window as any).fbq === 'function') (window as any).fbq('trackCustom', 'LoginRealizado');
    }

    return true
  }, []);

  const signOut = useCallback(() => {
    StorageLogout();
    setData({} as AuthState);
    _setDataUser({} as DataUser);
    setIsLogged(false)
    if (typeof (window as any).fbq === 'function') (window as any).fbq('trackCustom', 'LogoutRealizado');
  }, []);

  const updateUser = useCallback(
    async (dataUser: DataUser): Promise<any> => {
      try {
        await api.put("/cadastro", dataUser);
        localStorage.setItem("@FPontos:dataUser", JSON.stringify(dataUser));
        _setDataUser(dataUser);
      } catch (error) {
        throw error;
        console.log(error);
      }
    },
    [_setDataUser]
  );

const updateDataUser = async () => {
  try {
    const { data } = await api.get("/cadastro/consultarCadastroLogado");
    if (!data) return;
    _setDataUser(data);
    localStorage.setItem("@FPontos:dataUser", JSON.stringify(data));    
    return data;
  } catch (error) {
    console.log(error);
  }
}

  const validarDataUser = () => {
    if (_dataUser === null || _dataUser === undefined || !_dataUser.id) {
      if (token) {
        api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        updateDataUser();
      }
      return undefined;
    }
    
    return _dataUser;
  }

  const dataUser = validarDataUser();

  return (
    <AuthContext.Provider
      value={{
        user: data.user,
        dataUser,
        isLogged,
        signIn,
        signOut,
        updateUser,
        updateDataUser,
        useDisclosure,
        signInFacebook,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

function useAuth(): AuthContextProps {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }

  return context;
}



export { AuthProvider, useAuth };